/**
 * The Store Documents page's tabs (profile plan item 93): the rental
 * agreement, the pickup instructions, and the order notes, named the way
 * `?tab=` names them. The page opens the one a link names; the store's
 * old page URLs redirect to the page when their `?tab=` is one of these
 * (StoreProfileRedirect) and to Profile otherwise.
 */
export const STORE_DOCUMENT_TABS = ['rental', 'pickup', 'default-notes'] as const

export type StoreDocumentTab = (typeof STORE_DOCUMENT_TABS)[number]

export const isStoreDocumentTab = (value: string | null): value is StoreDocumentTab =>
  STORE_DOCUMENT_TABS.some((tab) => tab === value)
